import * as React from "react";
import { IconPresentationProps } from "@insite/mobius/Icon/Icon";

const Twitter: React.FC<IconPresentationProps> = props => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="59" height="58" viewBox="0 0 59 58">
            <g id="Tw" transform="translate(-9653.309 -6042.478)">
                <g
                    id="Area_SIZE:MEDIUM_STATE:DEFAULT_STYLE:STYLE2_"
                    data-name="Area [SIZE:MEDIUM][STATE:DEFAULT][STYLE:STYLE2]"
                    transform="translate(9653.309 6042.478)"
                    fill="none"
                    stroke="#fff"
                    stroke-width="2"
                >
                    <rect width="59" height="58" rx="29" stroke="none" />
                    <rect x="1" y="1" width="57" height="56" rx="28" fill="none" />
                </g>
                <g
                    id="Icon_ICON_feather_twitter_SIZE_MEDIUM_STATE_DEFAULT_STYLE_STYLE2_"
                    data-name="Icon [ICON=feather/twitter][SIZE=MEDIUM][STATE=DEFAULT][STYLE=STYLE2]"
                    transform="translate(9670.724 6059.195)"
                >
                    <rect
                        id="Area_ICON:feather_twitter_SIZE:MEDIUM_STATE:DEFAULT_STYLE:STYLE2_"
                        data-name="Area [ICON:feather/twitter][SIZE:MEDIUM][STATE:DEFAULT][STYLE:STYLE2]"
                        width="25"
                        height="24"
                        transform="translate(-0.415 0.282)"
                        fill="rgba(253,73,198,0.35)"
                        opacity="0"
                    />
                    <g id="Icon" transform="translate(0 2.264)">
                        <path
                            id="_0142e44f-ed72-4053-b035-23366a66bd6a"
                            data-name="0142e44f-ed72-4053-b035-23366a66bd6a"
                            d="M25.473,2.729a12.157,12.157,0,0,1-3.505,1.708,5,5,0,0,0-8.777,3.349V8.9A11.9,11.9,0,0,1,3.142,3.846S-1.324,13.895,8.725,18.362A13.007,13.007,0,0,1,.909,20.595c10.049,5.582,22.331,0,22.331-12.841a4.982,4.982,0,0,0-.09-.926A8.618,8.618,0,0,0,25.473,2.729Z"
                            transform="translate(-0.909 -2.718)"
                            fill="none"
                            stroke="#fff"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="2"
                        />
                    </g>
                </g>
            </g>
        </svg>
    );
};

export default React.memo(Twitter);
